import { Injectable } from '@angular/core';
import { throwAPIError } from '../_helpers/functions/errors';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadLocalFileAPIService {
  readonly #error = throwAPIError('DownloadFileAPIService');

  constructor(protected httpClient: HttpClient) {}

  public downloadLocalFile(path: string): Observable<HttpEvent<Blob>> {
    const error = this.#error('downloadFile');

    if (!path) {
      error('organization');
    }

    return this.httpClient.get(path, {
      responseType: 'blob',
      observe: 'events',
      reportProgress: true,
    });
  }
}
